import { experience } from './experience';
import type { CurrentlyItem, Education, Interest, Stat } from '../types';

export const author = {
  name: 'Denys Papushaiev',
  handle: '@denqxotl',
  shortHandle: 'denqxotl',
  role: 'Senior Software Engineer',
  location: 'Poland',
  timezone: 'Europe/Warsaw',
  timezoneLabel: 'CET',
  city: 'Poland',
  email: 'me@denqxotl.com',
  avatarSrc: '/avatar.jpg',
  careerStart: new Date('2015-04-01T00:00:00Z'),
} as const;

/** Full years elapsed from `author.careerStart` until `now`. */
export function getYearsOfExperience(now: Date = new Date()): number {
  const start = author.careerStart;
  let years = now.getFullYear() - start.getFullYear();
  const monthDiff = now.getMonth() - start.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < start.getDate())) {
    years -= 1;
  }
  return Math.max(0, years);
}

export function getSummary(now: Date = new Date()): string {
  const years = getYearsOfExperience(now);
  return `Senior software engineer with ${years}+ years of experience building web products, mostly with Ruby, Rails, and modern frontend tooling. I focus on maintainable systems, clear architecture, and practical delivery.`;
}

export const profileBullets: readonly string[] = [
  'Backend-first product engineering',
  'Rails veteran, learning Rust & Go',
  'Distributed systems: queues, APIs, services',
  'Pragmatic architecture over astronautics',
];

export function getStats(now: Date = new Date()): readonly Stat[] {
  return [
    { value: `${getYearsOfExperience(now)}+`, label: 'Years shipping' },
    { value: String(experience.length), label: 'Companies' },
    { value: '∞', label: 'Rails consoles opened' },
  ];
}

export const currentlyDoing: readonly CurrentlyItem[] = [
  { key: 'Building', value: 'Installment & short-term lending in the US · NinjaHoldings' },
  { key: 'Learning', value: 'Rust, Go, and the small design decisions that age well' },
  { key: 'Editor', value: 'Rust-based Zed' },
  { key: 'Off hours', value: 'Snowboarding, tennis, guitar' },
];

export const interests: readonly Interest[] = [
  { name: 'Snowboarding', icon: '◇' },
  { name: 'Guitars', icon: '♪' },
  { name: 'Vim / Neovim', icon: '⌘' },
  { name: 'Learning new tech', icon: '→' },
];

export const education: readonly Education[] = [
  {
    school: 'Cherkasy State Technological University',
    detail: "Master's Degree, Computer Science · 2017 — 2018",
  },
  {
    school: 'Cherkasy State Technological University',
    detail: "Bachelor's Degree, Computer Science · 2013 — 2017",
  },
];
